import { OriginalMenuCategory, OriginalMenuCategoryData } from './index';
import { ReadCollectionGql } from './gql';

type Data = {
  documents: OriginalMenuCategoryData[];
  nextToken: string;
};

class OriginalMenuCategoryCollection {

  readonly documents: OriginalMenuCategory[];
  readonly nextToken: string;

  constructor(data: Data = { documents: [], nextToken: '' }) {
    this.documents = data.documents.map(it => new OriginalMenuCategory(it));
    this.nextToken = data.nextToken;
  }

  async readAll(): Promise<this> {
    let collection = this;
    while (collection.nextToken) {
      const gql = await new ReadCollectionGql().fetch({ nextToken: collection.nextToken });
      if (!gql.result) throw new Error('invalid result');
      collection = collection.merge(new OriginalMenuCategoryCollection(gql.result));
    }
    return collection;
  }

  async readAllDishCategories(): Promise<this> {
    const documents = await Promise.all(this.documents.map(it => it.readAllDishCategories()));
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  merge(collection: OriginalMenuCategoryCollection): this {
    const documents = OriginalMenuCategory.sort([...this.documents, ...collection.documents]);
    const nextToken = collection.nextToken;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents, nextToken });
  }

  add(category: OriginalMenuCategory): this {
    const documents = OriginalMenuCategory .sort([...this.documents, category]);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  replace(category: OriginalMenuCategory): this {
    const documents = OriginalMenuCategory.sort(this.documents.map(it => it.id === category.id ? category : it));
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  remove(category: OriginalMenuCategory): this {
    const documents = this.documents.filter(it => it.id !== category.id);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  toJSON(): Data {
    const { nextToken } = this;
    const documents = this.documents.map(it => it.toJSON());
    return { documents, nextToken };
  }

  static async read(): Promise<OriginalMenuCategoryCollection> {
    const gql = await new ReadCollectionGql().fetch();
    if (!gql.result) throw new Error('invalid result');
    return new OriginalMenuCategoryCollection(gql.result);
  }

}

export { OriginalMenuCategoryCollection };
export type { Data as OriginalMenuCategoryCollectionData };